<template>
  <v-card
    rounded="sm"
    :href="link"
    @click.prevent="handleLink"
    v-intersect.once="handleView"
    elevation="0"
    class="proposal-img"
  >
    <v-img :src="src" :alt="proposal.name" />
  </v-card>
</template>
<script>
import get from "lodash/get";
import banner from "~/mixins/banner";
export default {
  name: "ProposalImage",
  props: {
    proposal: { type: Object, required: true }
  },
  mixins: [banner],
  computed: {
    src() {
      let prop =
        "metaData.category_proposal_type." +
        (!this.$vuetify.breakpoint.xsOnly ? "IMAGE_DESKTOP" : "IMAGE_MOBILE");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
